import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'An author removed a sub-page from a collection share link',
  name: 'subpage_removed',
};

export default META;
